import React, { createContext, ReactNode, useCallback, useContext, useMemo } from 'react';

import { useLocalStorageState } from '../hooks/useLocalStorageState';
import { ThemeMode } from '../theme';

export const THEME_MODE_LS_KEY = 'theme_mode';

export const ThemeModeContext = createContext({
  themeMode: 'light',
} as {
  themeMode: ThemeMode;
  toggleThemeMode: VoidFunction;
});

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeModeProvider = ({ children }: ThemeProviderProps) => {
  const [themeMode, setThemeMode] = useLocalStorageState(THEME_MODE_LS_KEY, 'light');

  const handleToggleThemeMode = useCallback(() => {
    setThemeMode((themeMode as ThemeMode) === 'light' ? 'dark' : 'light');
  }, [themeMode, setThemeMode]);

  const value = useMemo(
    () => ({
      themeMode: themeMode as ThemeMode,
      toggleThemeMode: handleToggleThemeMode,
    }),
    [themeMode, handleToggleThemeMode],
  );

  return <ThemeModeContext.Provider value={value}>{children}</ThemeModeContext.Provider>;
};

export function useThemeMode() {
  return useContext(ThemeModeContext);
}
